import { render, staticRenderFns } from "./UpdateTStockToNhanh.vue?vue&type=template&id=2f46008c"
import script from "./UpdateTStockToNhanh.vue?vue&type=script&lang=js"
export * from "./UpdateTStockToNhanh.vue?vue&type=script&lang=js"
import style0 from "./UpdateTStockToNhanh.vue?vue&type=style&index=0&id=2f46008c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports